module.exports = __webpack_public_path__ + "img/camera.38ec0b82.svg";